module.exports = __webpack_public_path__ + "static/media/IBO-101.41a8c680.png";